import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
interface WaveScreenMessageProps {
  readonly title: ReactNode;
  readonly description: ReactNode;
  readonly action?: ReactNode;
}
export default function WaveScreenMessage(t0) {
  const $ = _c(10);
  const {
    title,
    description,
    action
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="tw-mb-4 tw-text-xl tw-font-bold tw-text-iron-50">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <p className="tw-mb-6 tw-max-w-md tw-text-sm tw-text-iron-400 sm:tw-text-base">{description}</p>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== action) {
    t3 = action !== undefined && action !== null ? <div className="tw-flex tw-justify-center">{action}</div> : null;
    $[4] = action;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}